@if (this.notification && this.notification.success && this.notification.success.length > 0) {
<div>
  <ngb-alert
    insert-alert-icon
    [dismissible]="true"
    type="success"
    (closed)="closeNotification()"
    autoFocus
    tabindex="0"
  >
    <div id="successMessage">{{ mainMessages.success }}</div>
    @if (notification.success[0] !== defaultSuccessValue) {
    <ul>
      @for (message of notification.success; track message) {
      <li>{{ message }}</li>
      }
    </ul>
    } @if (showLink()) {
    <div>
      <button id="successLink" type="button" class="btn btn-link me-2" (click)="openDisplay()">
        <span class="fa-clipboard-list df-icon-wtd me-2"></span>{{ geFirstLinkText() }}
      </button>
    </div>
    }
  </ngb-alert>
</div>
} @if (notification && notification.warning && notification.warning.length > 0) {
<div>
  <ngb-alert
    insert-alert-icon
    [dismissible]="true"
    type="warning"
    (closed)="closeNotification()"
    autoFocus
    tabindex="0"
  >
    <div id="warningMessage">{{ mainMessages.warning }}</div>
    <ul>
      @for (message of notification.warning; track message) {
      <li>{{ message }}</li>
      }
    </ul>
  </ngb-alert>
</div>
} @if (notification && notification.error && notification.error.length > 0) {
<div>
  <ngb-alert insert-alert-icon [dismissible]="true" type="danger" (closed)="closeNotification()" autoFocus tabindex="0">
    <div id="errorMessage">{{ mainMessages.error }}</div>
    <ul>
      @for (message of notification.error; track message) {
      <li>{{ message }}</li>
      }
    </ul>
  </ngb-alert>
</div>
}
